import { render } from "./DataExtractorPage.vue?vue&type=template&id=374d492f&scoped=true"
import script from "./DataExtractorPage.vue?vue&type=script&lang=js"
export * from "./DataExtractorPage.vue?vue&type=script&lang=js"

import "./DataExtractorPage.vue?vue&type=style&index=0&id=374d492f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-374d492f"]])

export default __exports__